import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) return items;

    const lowerSearch = searchText.toLowerCase();

    return items.filter(item => this.searchInObject(item, lowerSearch));
  }

  private searchInObject(obj: any, searchText: string): boolean {
    for (const key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      const value = obj[key];

      if (typeof value === 'string') {
        if (value.toLowerCase().includes(searchText)) {
          return true;
        }
      } else if (typeof value === 'object' && value !== null) {
        if (this.searchInObject(value, searchText)) {
          return true;
        }
      }
    }
    return false;
  }
}
